import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './UserDashboard.css';

const UserDashboard = () => {
  const { user, logout, token, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();

  // Redirect admin users to admin dashboard
  useEffect(() => {
    if (isAdmin()) {
      navigate('/admin', { replace: true });
    }
  }, [isAdmin, navigate]);

  // Don't render anything if not authenticated
  if (!token || !user || !isAuthenticated()) {
    return null;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="user-dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>User Dashboard</h1>
          <div className="user-info">
            <span>Welcome, {user?.username}</span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="dashboard-cards">
          <div className="profile-card">
            <div className="card-header">
              <h2>Your Profile</h2>
            </div>
            <div className="card-content">
              <div className="profile-info">
                <div className="profile-field">
                  <label>Username:</label>
                  <span>{user?.username}</span>
                </div>
                <div className="profile-field">
                  <label>Role:</label>
                  <span className="role-badge user-role">{user?.role}</span>
                </div>
                <div className="profile-field">
                  <label>Access Level:</label>
                  <span>Read Only</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="main-card">
            <div className="card-header">
              <h2>Welcome to Your Dashboard</h2>
              <p>Access your personal information and available features</p>
            </div>
            <div className="card-content">
              <div className="welcome-content">
                <p>As a regular user, you have access to view your profile information and use the available features below.</p>
                <p>For product management features, please contact your administrator.</p>
                
              </div>
            </div>
          </div>
          
          <div className="secondary-cards">
            <div className="card">
              <h3>Favorites</h3>
              <p>Save your favorite products</p>
              <button className="card-button">Coming Soon</button>
            </div>
            
            <div className="card">
              <h3>Reports</h3>
              <p>Generate product reports</p>
              <button className="card-button">Coming Soon</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserDashboard;
